import React from 'react';
import { AccountGroupsVM } from './account-groups.viewmodel';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';

const AccountGroupsContext = React.createContext<AccountGroupsVM>(null);
const connectAccountGroupsVM = makeConnect(AccountGroupsContext);

export { AccountGroupsContext, connectAccountGroupsVM };
